import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=d11b20e2&scoped=true"
import script from "./ProductForm.vue?vue&type=script&lang=js"
export * from "./ProductForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d11b20e2",
  null
  
)

export default component.exports